<template>
  <div class="sp">
    <div class="sp-brew" :style="{ width: scrollProgress + '%' }"></div>

    <header class="sp-nav" :class="{ 'sp-scrolled': scrolled }">
      <a class="sp-lockup" @click="$router.push('/')">
        <img src="../assets/tcb-cup.png" alt="The Coffee Break cup logo" />
        <span>The Coffee Break</span>
      </a>
      <div class="sp-nav-actions">
        <div class="sp-menu-wrap" ref="menuWrap">
          <button
            class="sp-menu-btn"
            @click="menuOpen = !menuOpen"
            :aria-expanded="menuOpen"
          >
            Menu
          </button>
          <div class="sp-menu-dropdown" :class="{ 'sp-menu-open': menuOpen }">
            <a @click="goto('/')">Home</a>
            <a @click="goto('/about')">About</a>
            <a @click="goto('/career')">Career</a>
            <a @click="onManageAccount">Manage Account</a>
          </div>
        </div>
        <button class="sp-cta" @click="focusFinalEmail">Subscribe — Free</button>
      </div>
    </header>

    <main>
      <section class="ab-support">
        <div class="sp-wrap ab-support-wrap">
          <div class="sp-kicker" v-reveal>Thank you</div>
          <h1 class="sp-display ab-legal-title">
            <span class="sp-row"><span>Thank</span></span>
            <span class="sp-row"><span><em class="sp-cupword">you.</em></span></span>
          </h1>

          <div class="ab-support-copy" v-reveal>
            <p>Transaction successful.</p>
            <p>Thanks for contributing to our Tabung Kopi and helping us keep the lights on!</p>
            <p>You can log in via 'Manage Account' in the Menu on top to manage your subscription.</p>
            <p>If you have further questions, refer to our <a @click="goto('/ilovetcb')">FAQ</a>.</p>
          </div>

          <div class="ab-status-actions" v-reveal>
            <button class="sp-go" @click="onManageAccount">
              Manage subscription <span class="sp-arr">→</span>
            </button>
            <a class="ab-status-link" @click="goto('/')">Back to home</a>
          </div>

          <div class="ab-social" v-reveal>
            <a
              class="ab-social-btn ab-fb"
              href="https://www.facebook.com/breakmycoffee"
              target="_blank"
              rel="noopener"
            >
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                <path
                  d="M22 12.06C22 6.48 17.52 2 11.94 2S1.88 6.48 1.88 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.42V9.91c0-2.39 1.42-3.72 3.6-3.72 1.04 0 2.13.19 2.13.19v2.35h-1.2c-1.18 0-1.55.74-1.55 1.5v1.8h2.64l-.42 2.91h-2.22V22c4.78-.76 8.44-4.92 8.44-9.94Z"
                ></path>
              </svg>
              The Coffee Break
            </a>
            <a
              class="ab-social-btn ab-tw"
              href="https://twitter.com/BreakMyCoffee"
              target="_blank"
              rel="noopener"
            >
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                <path
                  d="M23 4.98c-.88.39-1.83.65-2.82.77a4.93 4.93 0 0 0 2.16-2.72c-.95.56-2 .97-3.13 1.19a4.92 4.92 0 0 0-8.38 4.48A13.94 13.94 0 0 1 1.67 3.15a4.9 4.9 0 0 0 1.52 6.57 4.9 4.9 0 0 1-2.23-.62v.06a4.92 4.92 0 0 0 3.95 4.83 4.9 4.9 0 0 1-2.22.08 4.93 4.93 0 0 0 4.6 3.42A9.87 9.87 0 0 1 0 19.54a13.94 13.94 0 0 0 7.55 2.21c9.06 0 14.02-7.5 14.02-14.02 0-.21 0-.42-.02-.63A10 10 0 0 0 23 4.98Z"
                ></path>
              </svg>
              @breakmycoffee
            </a>
          </div>
        </div>
      </section>

      <section class="sp-final">
        <div class="sp-sun"></div>
        <div class="sp-wrap">
          <div class="sp-kicker sp-kicker--center" v-reveal>One email. Every weekday.</div>
          <h2 v-reveal>Wake up<br /><em>already caught up.</em></h2>
          <p v-reveal>Join &gt;24,000 Malaysians. Unsubscribe anytime — no hard feelings.</p>
          <form class="sp-capture sp-capture--center" v-reveal @submit.prevent="subscribeFinal">
            <input
              ref="finalEmail"
              v-model="finalEmail"
              type="email"
              required
              placeholder="you@email.com"
              aria-label="Email address"
            />
            <button class="sp-go" type="submit" :class="{ 'sp-go--ok': finalState === 'done' }">
              <template v-if="finalState === 'brewing'">Brewing… ☕</template>
              <template v-else-if="finalState === 'done'">You're in ✓</template>
              <template v-else>Subscribe <span class="sp-arr">→</span></template>
            </button>
          </form>
          <div class="sp-referral sp-referral--center sp-referral--after" v-reveal>
            <span class="sp-referral-label">Referral code</span>
            <input
              v-model="referral"
              class="sp-referral-input"
              placeholder="Referral code"
              aria-label="Referral code"
            />
          </div>
          <div class="sp-note" v-reveal>Free forever · No spam · 3-minute read</div>
        </div>
        <footer>
          <span>Copyright © 2023 FINLIT MEDIA TECH GROUP SDN BHD (1348643-U)</span>
          <span>Brewed in Kuala&nbsp;Lumpur ☕</span>
          <span>
            <a @click="$router.push('/about')">About</a> ·
            <a href="https://thecoffeebreak.substack.com/archive" target="_blank" rel="noopener">Archive</a> ·
            <a @click="$router.push('/ilovetcb')">Support us</a> ·
            <a @click="$router.push('/privacy-policy')">Privacy Policy</a> ·
            <a @click="$router.push('/terms-of-service')">Terms of Service</a>
          </span>
        </footer>
      </section>
    </main>
  </div>
</template>

<script>
import axios from "axios";

const SUBSCRIBE_URL =
  "https://hukopzhug3.execute-api.ap-southeast-1.amazonaws.com/production/email/submit";

export default {
  name: "PaymentSuccessNew",
  directives: {
    reveal: {
      inserted(el) {
        el.classList.add("sp-reveal");
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          el.classList.add("sp-in");
          return;
        }
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add("sp-in");
                io.unobserve(el);
              }
            });
          },
          { threshold: 0.1 }
        );
        io.observe(el);
      },
    },
  },
  data() {
    return {
      menuOpen: false,
      scrolled: false,
      scrollProgress: 0,
      finalEmail: "",
      finalState: "idle",
      referral: "",
    };
  },
  mounted() {
    document.title = "Payment Success — The Coffee Break";
    const urlParams = new URLSearchParams(window.location.search);
    this.referral = urlParams.get("referral") || urlParams.get("ref") || "";
    window.addEventListener("scroll", this.onScroll, { passive: true });
    document.addEventListener("click", this.onDocClick);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    document.removeEventListener("click", this.onDocClick);
  },
  methods: {
    onScroll() {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      this.scrollProgress = max > 0 ? (h.scrollTop / max) * 100 : 0;
      this.scrolled = h.scrollTop > 40;
    },
    onDocClick(e) {
      if (this.menuOpen && this.$refs.menuWrap && !this.$refs.menuWrap.contains(e.target)) {
        this.menuOpen = false;
      }
    },
    goto(path) {
      this.menuOpen = false;
      this.$router.push(path);
    },
    onManageAccount() {
      this.menuOpen = false;
      window.open("https://billing.stripe.com/p/login/14k5mT1L4aFi6TC8ww", "_blank", "noreferrer");
    },
    focusFinalEmail() {
      this.$refs.finalEmail.scrollIntoView({ behavior: "smooth", block: "center" });
      this.$refs.finalEmail.focus();
    },
    async subscribeFinal() {
      const emailVal = this.finalEmail.trim();
      if (!emailVal) return;
      this.finalState = "brewing";
      try {
        this.$gtag.event("subscribe", {
          event_label: "subscribe_payment_success_new",
          value: emailVal,
        });
        await axios.post(SUBSCRIBE_URL, { email: emailVal, referral: this.referral.trim() });
        this.finalState = "done";
        this.finalEmail = "";
      } catch {
        this.finalState = "idle";
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,400;12..96,600;12..96,800&family=Instrument+Serif:ital@0;1&family=Roboto+Mono:wght@400;500&display=swap");
</style>

<style scoped>
.sp {
  --paper: #faf7f0;
  --paper-2: #f3eee2;
  --ink: #101820;
  --ink-2: #3d4852;
  --ink-3: #7a8691;
  --blue: #007cb7;
  --blue-deep: #083d73;
  --sky: #e3f2fd;
  --volt: #ffdb00;
  --line: rgba(16, 24, 32, 0.14);
  --serif: "Instrument Serif", Georgia, serif;
  --grotesk: "Bricolage Grotesque", "Helvetica Neue", sans-serif;
  --mono: "Roboto Mono", Menlo, monospace;
  --ease: cubic-bezier(0.16, 1, 0.3, 1);

  font-family: var(--grotesk);
  background: var(--paper);
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
  position: relative;
  min-height: 100vh;
}
.sp *,
.sp *::before,
.sp *::after {
  box-sizing: border-box;
}
.sp ::selection {
  background: var(--volt);
  color: var(--ink);
}

/* brew bar */
.sp-brew {
  position: fixed;
  top: 0;
  left: 0;
  height: 3px;
  background: var(--blue);
  z-index: 65;
}

/* nav */
.sp-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 32px;
  transition: background 0.3s, box-shadow 0.3s;
}
.sp-scrolled {
  background: rgba(250, 247, 240, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: 0 1px 0 var(--line);
}
.sp-lockup {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: var(--ink);
  cursor: pointer;
}
.sp-lockup img {
  height: 30px;
  display: block;
}
.sp-lockup span {
  font-weight: 800;
  font-size: 16px;
  letter-spacing: -0.02em;
}
.sp-nav-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}
.sp-menu-wrap {
  position: relative;
}
.sp-menu-btn {
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.02em;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  padding: 10.5px 20px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}
.sp-menu-btn:hover {
  border-color: var(--blue);
  background: rgba(0, 124, 183, 0.06);
}
.sp-menu-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 200px;
  background: var(--paper);
  border: 1.5px solid var(--line);
  border-radius: 16px;
  padding: 10px;
  box-shadow: 0 20px 40px rgba(16, 24, 32, 0.14);
  display: none;
  flex-direction: column;
}
.sp-menu-dropdown.sp-menu-open {
  display: flex;
}
.sp-menu-dropdown a {
  font-family: var(--grotesk);
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  text-decoration: none;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.sp-menu-dropdown a:hover {
  background: var(--sky);
  color: var(--blue);
}
/* desktop: list the links inline instead of behind the Menu button */
@media (min-width: 961px) {
  .sp-menu-btn {
    display: none;
  }
  .sp-menu-dropdown {
    position: static;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;
    min-width: 0;
    padding: 0;
    background: transparent;
    border: none;
    box-shadow: none;
  }
  .sp-menu-dropdown a {
    white-space: nowrap;
  }
}
.sp-cta {
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.02em;
  color: var(--paper);
  background: var(--ink);
  border: none;
  border-radius: 999px;
  padding: 12px 22px;
  cursor: pointer;
  transition: transform 0.3s var(--ease), background 0.3s;
}
.sp-cta:hover {
  background: var(--blue);
  transform: scale(1.05);
}
@media (max-width: 720px) {
  .sp-nav-actions {
    gap: 8px;
  }
  .sp-menu-btn {
    padding: 9px 14px;
    font-size: 12px;
  }
  .sp-cta {
    padding: 10px 16px;
    font-size: 12px;
  }
  .sp-nav {
    padding: 14px 18px;
  }
}
@media (max-width: 420px) {
  .sp-lockup span {
    display: none;
  }
}

/* hero */
.ab-support {
  padding: 170px 0 100px;
}
.ab-support-wrap {
  max-width: 640px;
}
.sp-kicker {
  font-family: var(--mono);
  font-size: 12px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--ink-3);
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}
.sp-kicker::before {
  content: "";
  width: 44px;
  height: 1px;
  background: currentColor;
}
.sp-kicker--center {
  justify-content: center;
}
.sp-display {
  font-weight: 800;
  font-size: clamp(48px, 9vw, 120px);
  line-height: 0.92;
  letter-spacing: -0.04em;
  margin: 0 0 24px;
  text-transform: uppercase;
}
.sp-row {
  display: block;
  overflow: hidden;
}
.sp-row > span {
  display: inline-block;
  transform: translateY(110%);
  animation: sp-rise 1.1s var(--ease) forwards;
}
.sp-row:nth-child(2) > span {
  animation-delay: 0.12s;
}
@keyframes sp-rise {
  to {
    transform: translateY(0);
  }
}
.sp-display em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  text-transform: none;
  letter-spacing: -0.01em;
  color: var(--blue);
}
.sp-cupword {
  position: relative;
  white-space: nowrap;
}
.sp-cupword::after {
  content: "";
  position: absolute;
  left: -2%;
  right: -2%;
  bottom: 6%;
  height: 0.18em;
  background: var(--volt);
  z-index: -1;
  transform: scaleX(0);
  transform-origin: left;
  animation: sp-swipe 0.8s var(--ease) 1s forwards;
}
@keyframes sp-swipe {
  to {
    transform: scaleX(1);
  }
}
.ab-support-copy p {
  font-size: 17px;
  line-height: 1.65;
  color: var(--ink-2);
  margin: 0 0 18px;
}
.ab-support-copy a {
  color: var(--blue);
  cursor: pointer;
  text-decoration: underline;
}
@media (max-width: 720px) {
  .ab-support {
    padding: 120px 0 60px;
  }
}

/* status page actions */
.ab-status-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 8px;
  flex-wrap: wrap;
}
.ab-status-link {
  font-size: 14px;
  font-weight: 700;
  color: var(--ink-2);
  text-decoration: underline;
  cursor: pointer;
}

/* social buttons */
.ab-social {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 32px;
}
.ab-social-btn {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 11px 18px;
  border-radius: 999px;
  font-family: var(--grotesk);
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  color: #fff;
  transition: transform 0.2s var(--ease), opacity 0.2s;
}
.ab-social-btn:hover {
  opacity: 0.92;
  transform: scale(1.03);
}
.ab-fb {
  background: #1877f2;
}
.ab-tw {
  background: #1da1f2;
}

/* shared */
.sp-wrap {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 32px;
}
@media (max-width: 720px) {
  .sp-wrap {
    padding: 0 18px;
  }
}
.sp-reveal {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.9s var(--ease), transform 0.9s var(--ease);
}
.sp-reveal.sp-in {
  opacity: 1;
  transform: none;
}

.sp-referral {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
}
.sp-referral--center {
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 8px;
  max-width: 520px;
}
.sp-referral--after {
  margin-top: 20px;
  margin-bottom: 0;
  opacity: 0.75;
}
.sp-referral-label {
  font-family: var(--mono);
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
  white-space: nowrap;
}
.sp-referral-input {
  height: 36px;
  padding: 0 16px;
  font-family: var(--grotesk);
  font-size: 13px;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  outline: none;
  flex: 1;
  transition: border-color 0.2s;
}
.sp-referral-input::placeholder {
  color: var(--ink-3);
}
.sp-referral-input:focus {
  border-color: var(--blue);
}
.sp-capture {
  display: flex;
  gap: 10px;
  flex: 1;
  max-width: 520px;
  min-width: 300px;
}
.sp-capture--center {
  margin: 0 auto;
  justify-content: center;
}
.sp-capture input {
  flex: 1;
  line-height: 1;
  padding: 9px 16px;
  font-family: var(--grotesk);
  font-size: 13px;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
}
.sp-capture input::placeholder {
  color: var(--ink-3);
}
.sp-capture input:focus {
  border-color: var(--blue);
  background: #fff;
}
.sp-go {
  height: 36px;
  padding: 0 20px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  background: var(--blue);
  color: #fff;
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  transition: background 0.25s;
  position: relative;
}
.sp-go:hover {
  background: var(--blue-deep);
}
.sp-go--ok {
  background: #27ae60;
}
.sp-arr {
  transition: transform 0.3s var(--ease);
  display: inline-block;
}
.sp-go:hover .sp-arr {
  transform: translateX(5px);
}
@media (max-width: 520px) {
  .sp-capture {
    flex-direction: column;
    min-width: 0;
    width: 100%;
  }
  .sp-capture input,
  .sp-go {
    width: 100%;
  }
  .sp-go {
    justify-content: center;
  }
}

/* final CTA */
.sp-final {
  padding: 150px 0 60px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.sp-sun {
  position: absolute;
  left: 50%;
  bottom: -32vw;
  transform: translateX(-50%);
  width: 64vw;
  height: 64vw;
  border-radius: 50%;
  background: radial-gradient(circle at 50% 30%, var(--sky) 0%, rgba(227, 242, 253, 0) 70%);
  pointer-events: none;
}
.sp-final h2 {
  font-weight: 800;
  font-size: clamp(44px, 8vw, 120px);
  line-height: 0.95;
  letter-spacing: -0.04em;
  text-transform: uppercase;
  margin: 0 0 18px;
  position: relative;
}
.sp-final h2 em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  text-transform: none;
  color: var(--blue);
}
.sp-final p {
  font-size: 17px;
  color: var(--ink-2);
  margin: 0 0 44px;
  position: relative;
}
.sp-final .sp-capture {
  margin: 0 auto;
  position: relative;
}
.sp-note {
  margin-top: 18px;
  font-family: var(--mono);
  font-size: 11.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink-3);
  position: relative;
}

@media (max-width: 720px) {
  .sp-final {
    padding: 90px 0 40px;
  }
  footer {
    margin-top: 64px;
  }
}

footer {
  margin-top: 130px;
  border-top: 1.5px solid var(--ink);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 26px 32px;
  font-family: var(--mono);
  font-size: 11.5px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
  flex-wrap: wrap;
  position: relative;
  background: var(--paper);
}
footer a {
  color: var(--ink);
  text-decoration: none;
  cursor: pointer;
}
footer a:hover {
  color: var(--blue);
}

@media (prefers-reduced-motion: reduce) {
  .sp-row > span {
    animation: none;
    transform: none;
  }
  .sp-cupword::after {
    animation: none;
    transform: scaleX(1);
  }
  .sp-reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
</style>
